// AudioSettings — persistence helper. The backend (player_music_profiles via /api/audio/*)
// is the source of truth; localStorage is only an offline/unauthenticated fallback.
import api from "../api";

const LS_KEY = "ff_audio_settings";

export const AUDIO_DEFAULTS = {
  music_enabled: false,
  music_volume: 0.6,
  effects_volume: 0.7,
  mute_all: false,
  calm_mode: false,
  reduced_intensity: false,
  dynamic_tension_enabled: true,
  beat_sync_enabled: false,
  preferred_intensity: "standard",
  reduced_bass: false,
  reduced_high_freq: false,
  mono_mix: false,
};

export function loadLocal() {
  try { return JSON.parse(localStorage.getItem(LS_KEY)) || null; } catch (e) { return null; }
}

export function saveLocal(settings) {
  try { localStorage.setItem(LS_KEY, JSON.stringify(settings)); } catch (e) { /* ignore quota */ }
}

// Fetch authoritative settings (+ flags). Falls back to local copy if the request fails.
export async function fetchSettings() {
  try {
    const { data } = await api.get("/audio/settings");
    if (data && data.settings) saveLocal(data.settings);
    return { settings: data.settings, flags: data.flags, source: "server" };
  } catch (e) {
    const local = loadLocal();
    return { settings: local || { ...AUDIO_DEFAULTS }, flags: null, source: "local" };
  }
}

// Persist a partial settings patch. Writes local immediately, then to the server.
export async function saveSettings(current, patch) {
  const merged = { ...current, ...patch };
  saveLocal(merged);
  try {
    const { data } = await api.put("/audio/settings", { settings: patch });
    if (data && data.settings) { saveLocal(data.settings); return { settings: data.settings, source: "server" }; }
  } catch (e) {
    return { settings: merged, source: "local" };
  }
  return { settings: merged, source: "local" };
}
